import React from 'react';
import './pagebase.scss';

const PageBase = (props) => {
  const { children } = props;

  return (
    <div className='pagebase-container'>
      <div className='pagebase-inner'>{children}</div>
    </div>
  );
};

export default PageBase;
